export default "__VITE_ASSET__oQVKWAdX__"